/*
 * @Author: Gang Jiang 
 * @Date: 2025-02-28 09:44:59 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2025-02-28 13:49:07
 */
<template>
  <div class="help-page">
    <breadcrumbs url="about-artemis-ads" lastTitle="Publisher FAQ"/>
    <div class="docs">
      <h1>Commissions and Sales Tracking</h1>
      <h2>What is the typical commission rate on Artemis Ads?</h2>
      <p>
        The commission rate varies depending on the product. Typically,
        commission rates typically range from 10% to 25%, but this may change
        based on the product category and any ongoing promotions.
      </p>
      <h2>Where can I find commission rate information?</h2>
      <p>
        You can view commission rates for each product on the products page.
      </p>
      <h2>How do I track my sales and commissions?</h2>
      <p>
        To track your sales and commissions, you must use your unique Artemis
        Ads attribution link in your promotions. This ensures that any sales
        generated from customers who click your link are properly credited to
        you.
      </p>
      <p>
        On <b class="fw600">ArtemisAds.com</b>, you can access the
        <b class="fw600">dashboard</b> and <b class="fw600">reports</b> menu to
        view your overall performance, as well as performance breakdowns by
        brand and product.
      </p>
      <p>Your commissions are calculated as follows:</p>
      <p><b class="fw600"
        >Commission Rate of the converted products (at the time of conversion) ×
        Commissionable Sales.</b
      ></p>
      <p>
        <b class="fw600">Important</b>: You should not combine Amazon
        Attribution links with Amazon Associates links.
      </p>
      <p>
        Amazon's policy prohibits using the same traffic to earn commissions
        from multiple programs.
      </p>
      <p>
        Amazon may take action against those who try to claim commissions from
        both Amazon Associates and another program using the same traffic.
      </p>
      <p>
        This includes manipulating or combining attribution links. Amazon may
        withhold commissions or terminate participation in the Associates
        program.
      </p>
      <h2>Where can I access my sales and commission data?</h2>
      <p>
        You can log into your Artemis Ads Affiliate dashboard and navigate to
        the Sales Reports tab. This section provides real-time reporting on
        clicks, sales, and earnings, helping you track performance and optimize
        your promotions.
      </p>
    </div>
  </div>
</template>
<script setup>
import Breadcrumbs from '../breadcrumbs.vue'
</script>